<template>
  <div class="dialog-modal">
    <div
      v-if="show"
      class="dialog-modal__overlay"
    />
    <vue-final-modal
      ref="dialog"
      v-model="show"
      :lock-scroll="false"
      :data-modal="name"
      :focus-retain="false"
      :focus-trap="false"
      :ssr="false"
      hide-overlay
      :min-width="minWidth"
      :width="width"
      classes="dialog-modal__container"
      content-class="dialog-modal__content"
      :content-style="{
        minWidth: `${minWidth}px`,
        width: `${minWidth || width}px`
      }"
      :name="modalName"
      @click-outside="onCancelClick"
      @before-close="willClose"
      @opened="opened"
      @closed="closed"
    >
      <tr-svg-icon
        classes="cursor-pointer margin-right margin-top pull-right"
        size="small"
        :on-button-click="onCancelClick"
        name="ic-close"
      />
      <div class="modal-content-container">
        <div class="modal-content-header">
          <span class="h2 no-margin">
            {{ title }}
          </span>
        </div>
        <div class="modal-content-body">
          <slot />
        </div>
        <div
          v-if="!hasItsOwnButtons"
          class="vertical-offset3 bottom-offset3 inline-block width-100"
        >
          <tr-button
            v-if="!hideCancelButton"
            classes="pull-left"
            :on-button-click="onCancelClick"
            :label="cancelButtonLabel ? cancelButtonLabel : 'Cancelar'"
            variant="outlined"
            color="secondary"
          />
          <tr-button
            v-if="onSave"
            classes="pull-right"
            :on-button-click="onSave"
            :label="saveButtonLabel || 'Salvar'"
            variant="raised"
            :color="saveButtonColor"
          />
          <slot
            v-if="show"
            name="buttons"
          />
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import { VueFinalModal } from 'vue-final-modal'
import TrButton from './TrButton.vue';
import TrSvgIcon from './TrSvgIcon.vue'

export default {
  name: 'TrDialog',
  components: {
    TrButton,
    TrSvgIcon,
    VueFinalModal
  },
  props: {
    name: {
      required: true,
      type: String
    },
    title: {
      required: false,
      type: String
    },
    uniqueName: {
      required: false,
      type: Boolean,
      default: false
    },
    onSave: {
      required: false,
      type: Function
    },
    cancelButtonLabel: {
      required: false,
      type: String
    },
    hideCancelButton: {
      required: false,
      type: Boolean,
      default: false
    },
    saveButtonLabel: {
      required: false,
      type: String,
      default: ''
    },
    saveButtonColor: {
      required: false,
      type: String,
      default: 'primary'
    },
    beforeClose: {
      required: false,
      type: Function
    },
    onOpened: {
      required: false,
      type: Function
    },
    onCancel: {
      required: false,
      type: Function
    },
    onClose: {
      required: false,
      type: Function
    },
    hasItsOwnButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    minWidth: {
      required: false,
      type: Number,
      default: 635
    },
    width: {
      required: false,
      type: Number
    }
  },
  data() {
    return {
      show: false,
      dialogStack: this.$injectDialogStack?.()
    }
  },
  computed: {
    modalName() {
      if (this.uniqueName) {
        return this.name + this._generateRandomId();
      }
      return this.name;
    }
  },
  methods: {
    open() {
      this.show = true;

      if (this.dialogStack) {
        this.dialogStack.open(this)
      }
    },
    close() {
      this.show = false;
    },
    opened() {
      if (this.onOpened) {
        this.onOpened();
      }
    },
    closed() {
      if (this.onClose) {
        this.onClose();
      }

      if (this.dialogStack) {
        this.dialogStack.close(this)
      }
    },
    onCancelClick() {
      this.close();

      if (this.onCancel) {
        this.onCancel();
      }
    },
    willClose() {
      if (this.beforeClose) {
        this.beforeClose();
      }
    },
    _generateRandomId() {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
    }
  }
};
</script>

<style scoped>
.dialog-modal {
  position: fixed;
  z-index: 1000;
}

:deep(.dialog-modal__container) {
  overflow: auto;
}

.dialog-modal__overlay {
  background-color: rgba(178, 193, 205, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

:deep(.dialog-modal__content) {
  background-color: #fff;
  text-align: left;
  border-radius: 3px;
  box-shadow: 0 20px 60px -2px rgb(27 33 58 / 40%);
  padding: 0;
  margin: auto;
  margin-top: 150px;
  margin-bottom: 150px;
}

.modal-content-body {
  display: flow-root;
}
</style>
